import allImgPaths from 'assets/images'
import { InputTextField } from 'components/InputField'
import Otp from 'components/Otp'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import objectiveIcon from "./../../assets/images/objective-icon.svg";
import CustomSelect from 'components/common/CustomSelect'
import RfpSocialLinks from 'components/rfp/rfpInnerBox/RfpSocialLinks'
import CustomCheckBox from 'components/CustomCheckBox'

const Onboarding6 = () => {

    const [formData, setFormData] = useState<any>('');

    const handleObjectiveChange = (event: any) => {
        setFormData({
            [event.target.name]: event.target.value,
        });
        if (event.target.name === "objective") {
            let getTextArea = document.getElementById("textAreaRef");
            if (getTextArea) {
                if (event.target.value.length === 0) {
                    event.target.style.height = "24px";
                } else {
                    event.target.style.height = "auto";
                    event.target.style.height = event.target.scrollHeight + "px";
                }
            }
        }
    };

    const facilityCategory = [
        { catName: 'Accommodation', imgUrl: allImgPaths.vendorAccomodationIcon },
        { catName: 'Food & Beverage', imgUrl: allImgPaths.vendorFoodIcon },
        { catName: 'Activities & Experiences', imgUrl: allImgPaths.vendorActivityIcon },
        { catName: 'Transportation', imgUrl: allImgPaths.vendorTransportationIcon },
        { catName: 'Gifting', imgUrl: allImgPaths.vendorGiftingIcon },
        { catName: 'Entertainment', imgUrl: allImgPaths.vendorEntertaintmentIcon },
        { catName: 'Decor & Rental', imgUrl: allImgPaths.vendorDecoreIcon },
        { catName: 'Technology Partner', imgUrl: allImgPaths.vendorTechIcon },
        { catName: 'Security & Stafffing', imgUrl: allImgPaths.vendorSecurityIcon },
        { catName: 'Marketing & Promotion', imgUrl: allImgPaths.vendorMarketingIcon },
        { catName: 'Others', imgUrl: allImgPaths.vendorOthersIcon }
    ]

    const facilityAdditionalFeature = [
        { catName: 'Parking'},
        { catName: 'Valet Parking'},
        { catName: 'Wheelchair accessibilty'},
        { catName: 'Public Transportation'},
        { catName: 'AV capabilites'},
        { catName: 'Business center, Fax, Printing'},
        { catName: 'Free Wi-Fi'},
        { catName: 'Onsite security'},
        { catName: 'Basic shopping'},
        { catName: 'ATMs'},
        { catName: 'Laundry Service'}
    ]

    return (
        <div className="flex">
            {/* Left banner */}
            <div className="w-2/6">
                <div className="bg-[#1E0AF5] flex flex-col justify-start items-center h-screen">
                    <div className="pt-[77px]">
                        <img className='pb-52 -ml-8' src={allImgPaths.vendorWhiteIcon} alt="" />

                        <div className="pb-10 last:pb-0 relative line-shape done">
                            <h3 className='text-sm font-interSemiBold text-white pb-1 circle-shape'>Basic Details</h3>
                            <ul>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>General Information</li>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>Contact Info</li>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>Social Media Presence</li>
                            </ul>
                        </div>

                        <div className="pb-10 last:pb-0 relative line-shape active">
                            <h3 className='text-sm font-interSemiBold text-white pb-1 circle-shape'>Facility Details</h3>
                            <ul>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>Count & capacity</li>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>Secondary services & features</li>
                            </ul>
                        </div>

                        <div className="pb-10 last:pb-0 relative line-shape">
                            <h3 className='text-sm font-interSemiBold text-white pb-1 circle-shape'>Legal & Compliances</h3>
                            <ul>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>Upload licenses, certification & Insurance</li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>

            {/* Right banner */}
            <div className="w-4/6 flex flex-col">
                <div className="w-full h-screen flex items-center overflow-y-auto">
                    <div className="w-full max-w-[650px] mx-auto">

                        {/* Heading */}
                        <h2 className="font-interSemiBold text-[30px] text-[#101828] pb-8">Facility Details</h2>

                        {/* Chips */}
                        <div className="">
                            <p className='text-base font-interSemiBold text-[#101828]'>Please select other categories that you offer as service <span className='text-base text-[#667085]'>(if any)</span> </p>
                            <div className='flex flex-wrap gap-4 mt-4 mb-8'>
                                {facilityCategory.map((item, idx) => {
                                    console.log(item)
                                    return (
                                        <span key={idx} className='font-interMedium text-[#344054] text-sm border border-[#EAECF0] rounded-2xl flex items-center gap-x-1.5 whitespace-nowrap px-2.5 py-1 bg-[#F9FAFB]'>
                                            <img src={item.imgUrl} alt={item.catName} />
                                            {item.catName}
                                        </span>
                                    )
                                })
                                }
                            </div>
                        </div>

                        {/* Additional Feature */}
                        <div className="">
                            <p className='text-base font-interSemiBold text-[#101828] pb-4'>Additional Features <span className='text-base text-[#667085]'>(select all that apply)</span> </p>

                            <div className="">
                                <div className="flex flex-wrap">
                                    {
                                        facilityAdditionalFeature.map((item, idx) => (
                                            <CustomCheckBox
                                                name=''
                                                label={item.catName}
                                                customLabelStyle='text-sm font-interMedium text-[#344054] inline-block pl-2'
                                                customStyle='w-1/2 pb-4'
                                            />
                                        ))
                                    }

                                </div>
                            </div>
                        </div>

                        <div className="flex items-center justify-between mt-10">
                            <Link className='text-[#4B3BF7] cursor-pointer font-interSemiBold text-sm hover:text-[#0C0462]' to={'/'}>
                                Skip this step
                            </Link>

                            <div className="flex gap-x-3 justify-end">
                                <button className="rounded-md border border-[#1E0AF5] text-[#1E0AF5] hover:bg-[#E8E6FE] flex gap-x-1.5 items-center !pl-2 !pr-4 font-interSemiBold" type="submit">
                                    <img className='w-[22px] h-[22px]' src={allImgPaths.vendorLeftArrowBlueIcon} alt="" />
                                    Prev
                                </button>
                                <button className="submit-btn-blue blue-btn-hover flex gap-x-1.5 items-center !pl-4 !pr-2" type="submit">
                                    Next
                                    <img className='w-[22px] h-[22px]' src={allImgPaths.vendorLeftArrowIcon} alt="" />
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Onboarding6